import InfoRoute from './AboutRoute';
import AboutLink from './AboutLink';
export default InfoRoute;
export { AboutLink };
